import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import ReactJson from 'react-json-view'
import Styles from '../../../common/styles'
import * as gdprActions from '../../../store/gdpr'

const mapStateToProps = state => ({
  gdpr: state.gdpr
})

const mapDispatchToProps = dispatch => ({
  gdprActions: bindActionCreators(gdprActions, dispatch)
})

class SearchResult extends Component {
  render () {
    const { classes, gdpr } = this.props
    if (!gdpr.information) return null
    return (
      <Paper className={classes.content}>
        {gdpr.information
          ? <ReactJson
            src={gdpr.information}
            enableClipboard={false}
            displayObjectSize={false}
            displayDataTypes={false}
            />
          : ''}
      </Paper>
    )
  }
}

SearchResult = connect(mapStateToProps, mapDispatchToProps)(SearchResult)
export default withStyles(Styles)(SearchResult)



// WEBPACK FOOTER //
// ./src/pages/gdpr/containers/search-result.js